<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'MFixedAssetEditorFieldset',
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    fixedAsset: {
      type: Object,
      required: true,
    },
    target: {
      type: String,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const labelAlign = ref('right');
  const ux = ref([]);

  const $data = computed(() => ({
    labelAlign: labelAlign.value,
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'labelAlign' }, { name: 'ux' }],
    loaders: {},
    ux: {},
    dataRefs: { labelAlign, ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.fixedAsset,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('fixedAsset');
    }
  );
  watch(
    () => props.target,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('target');
    }
  );

  const act_7315092382398562_reloadComponentData_hrpf9r0nl =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_6ugrtxhb9 =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_hrpf9r0nl,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_6ugrtxhb9],
    event: 'reload',
  });

  const actions = {
    inst_evh_7315092382398562_reload_6ugrtxhb9,
    inst_evh_7315092382398562_reload,
  };

  const evh_7315092382398562_reload_6ugrtxhb9 = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_6ugrtxhb9.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpUsercontrol
    :loading="loading"
    :reloading="reloading"
    :loaded="loaded"
    :error="error"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <FieldsetFixedAssetGeneral
      :fixedAsset="fixedAsset"
      :labelAlign="labelAlign"
      v-if="!target || target === 'general'"
    >
    </FieldsetFixedAssetGeneral>
    <FieldsetFixedAssetWasteBin
      :fixedAsset="fixedAsset"
      :labelAlign="labelAlign"
      v-if="target === 'wasteBin'"
    >
    </FieldsetFixedAssetWasteBin>
  </ItpUsercontrol>
</template>
